//Returns a vertical list of right justified field labels and left justified field values
import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ReadOnlyField from "components/Shared/ReadOnlyField";
import { zip } from "lodash";

export default class FieldGroup extends React.Component {

    constructor(props) {
        super(props);
        this.updateWidth = this.updateWidth.bind(this);
        this.state = {
            windowWidth: 0,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateWidth);
        this.updateWidth();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWidth);
    }

    updateWidth() {
        this.setState({
            windowWidth: window.innerWidth,
        });
    }

  render() {
    return (
      <div>
        {this.state.windowWidth < 600 ? (
          zip(this.props.labels, this.props.values).map(field => (
            <ReadOnlyField
              containerClassName="field-group-mobile"
              key={`${field[0]} ${field[1]}`}
              title={field[0]}
              fieldValue={field[1]}
              singeline
            />
          ))
        ) : (
          <Grid container className="field-group" spacing={1}>
            {zip(this.props.labels, this.props.values).map(([label, value]) => (
              <Grid container size={12} key={`${label} ${value}`}>
                <Grid size={4} className="field-group-labels">
                  <div className="field-label">{label}</div>
                </Grid>
                <Grid size={8} className="field-group-values">
                  <Typography className="field-value" sx={{ fontWeight: 'bold' }}>
                    {value}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    );
  }
}

FieldGroup.propTypes = {
  labels: PropTypes.array,
  values: PropTypes.array,
};
